export const init = (props = {}) => {
  const {uid, email} = props;
  if (!window.hj) {
    const {hotjar} = require('react-hotjar');
    hotjar.initialize(2268603, 6);
  }
  if (uid && window.hj) window.hj('identify', uid, {email});
};
